export const mbToken = 'pk.eyJ1IjoiZGFuc2hpIiwiYSI6ImNqeXZvYzkzZDA4cDgzaW1lNzQ3b2d2YncifQ.x6fRkv5z6lw7mgFz0YlW-A';